import { OwlOptions } from 'ngx-owl-carousel-o';

export function optionCarousel(bundle: string): OwlOptions {
  let optCarousel: OwlOptions;
  switch (bundle) {
    case 'blocco_immagine':
      return optCarousel = {
        loop: false,
        dots: false,
        lazyLoad: true,
        navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>'],
        responsive: {
          0: {
            items: 1
          }
        },
        autoWidth: true
      };
    case 'blocco_video':
      return optCarousel = {
        loop: false,
        dots: false,
        lazyLoad: true,
        autoWidth: false,
        autoHeight: false,
        navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>'],
        responsive: {
          0: {
            items: 1
          }
        }
      };
    case 'blocco_numero':
      return optCarousel = {
        loop: true,
        center: true,
        dots: true,
        navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>'],
        responsive: {
          0: {
            items: 1
          },
          500: {
            items: 3
          }
        }
      };
    case 'blocco_card':
      return optCarousel = {
        loop: false,
        mouseDrag: true,
        touchDrag: true,
        dots: false,
        navSpeed: 700,
        navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>'],
        nav: true
      };
    case 'blocco_paragrafo_immagine':
      return optCarousel = {
        loop: false,
        dots: true,
        lazyLoad: true,
        navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>'],
        responsive: {
          0: {
            items: 1
          }
        }
      };
    case 'blocco_quote_testimonial':
      return optCarousel = {
        loop: false,
        dots: true,
        lazyLoad: true,
        navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>'],
        responsive: {
          0: {
            items: 1
          }
        }
      };
    case 'blocco_date_to_remember':
      return optCarousel = {
        loop: false,
        dots: false,
        navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>'],
        responsive: {
          0: {
            items: 1
          },
          576: {
            items: 2
          },
          768: {
            items: 4
          },
          992: {
            items: 5
          }
        }
      };
    case 'blocco_visore_hero_1':
      return optCarousel = {
        loop: true,
        dots: false,
        lazyLoad: true,
        navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>'],
        responsive: {
          0: {
            items: 1
          }
        }
      };
    case 'blocco_logo_carousel':
      return optCarousel = {
        loop: false,
        dots: true,
        lazyLoad: true,
        navText: ['<i class="fa-solid fa-chevron-left" aria-hidden="true"></i>', '<i class="fa-solid fa-chevron-right" aria-hidden="true"></i>'],
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 2
          },
          800: {
            items: 3
          },
          1100: {
            items: 4
          }
        }
      };
    default:
      return optCarousel = {};
  }
}